<template>
  <div>
    <header>
      <div class="bc">
        <div class="header-img">
          <img
            :src="userInfo.HeadImageUrl?userInfo.HeadImageUrl+'?x-oss-process=image/resize,m_fill,h_170,w_170':defaultImg"
            :onerror="defaultImg"
            alt
          >
        </div>
        <div class="name">{{userInfo.RealName}}</div>
        <div class="code-img">
          <img src="@/assets/images/QR-code.png" alt>
        </div>
        <div class="hint">出示二维码，打卡签到</div>
        <footer-logo></footer-logo>
      </div>
    </header>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
export default {
  components: {
    'footer-logo': footerLogo
  },
  data() {
    return {
      userInfo: {
        HeadImageUrl: ''
      },
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  created() {
    this.getuserData()
  },
  methods: {
    getuserData() {
      var token = window.localStorage.getItem('ei_token')
      this.$fetch('/api/Membership/Info', {
        token: token
      }).then(result => {
        this.userInfo = result
      })
    }
  }
}
</script>

<style lang="less" scoped>
header {
  width: 100%;
  height: 320 / @rem-size;
  background: url('../../assets/images/ticket-bc.png');
  background-size: 100% 100%;
  position: relative;
  padding: 0 24 / @rem-size;

  .bc {
    width: 702 / @rem-size;
    height: auto;
    padding-top: 90 / @rem-size;
    background: #fff;
    border-radius: 8 / @rem-size;
    position: absolute;
    top: 136 / @rem-size;
    left: 0;
    right: 0;
    margin: auto;

    .header-img {
      width: 144 / @rem-size;
      height: 144 / @rem-size;
      border: 6 / @rem-size solid #fff;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      top: -75 / @rem-size;
      left: 0;
      right: 0;
      margin: auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .name {
      font-size: 36 / @rem-size;
      text-align: center;
      color: #333;
    }

    .code-img {
      width: 520 / @rem-size;
      height: 520 / @rem-size;
      margin: 0 auto;
      margin-top: 50 / @rem-size;
      border: 10 / @rem-size solid #e9f0f9;
      padding: 10 / @rem-size;

      img {
        height: 100%;
      }
    }

    .hint {
      font-size: 28 / @rem-size;
      color: #999;
      text-align: center;
      margin-top: 30 / @rem-size;
    }
  }
}
</style>
